import styled, { css } from 'styled-components';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';

export const Wrapper = styled.div`
  ${({ theme: { font } }) => font.mainFont()};
  background: linear-gradient(90deg, #2153fd 0%, #04bbff 100%);
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  position: absolute;
  inset: 0px;
  padding: 0 14px;
`;

export const PaymentStatusWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 320px;
`;

export const Header = styled.header`
  border-bottom: 1px solid ${({ theme: { color } }) => color.white_700};
  width: 100%;
  padding: 12px 0px;
  text-align: center;
  position: relative;
  z-index: 10;
`;

export const LogoWrapper = styled.div`
  position: relative;
`;

export const MerChantAvatar = styled(Avatar)`
  && {
    width: 120px;
    height: 120px;
    border: 2px solid ${({ theme: { color } }) => color.PLColor1};
  }
`;

export const StatusTitle = styled(Typography)`
  && {
    ${({ theme: { color } }) => {
      return css`
        color: ${color.white};
        font-weight: 500;
        font-size: 24px;
        line-height: 31px;
        padding-top: 40px;
      `;
    }}
  }
`;

export const AmountPaid = styled(Typography)`
  && {
    ${({ theme: { color } }) => {
      return css`
        color: ${color.white};
        font-weight: 500;
        font-size: 16px;
        padding-top: 16px;
      `;
    }}
  }
`;

export const BackToWebsite = styled.span`
  background: #ffffff;
  text-transform: uppercase;
  border: 1px solid #dbe1e6;
  box-sizing: border-box;
  border-radius: 100px;
  box-shadow: 0px 4px 16px rgba(32, 87, 254, 0.25);
  color: ${({ theme: { color } }) => color.PLColor1};
  cursor: pointer;
  display: inline-block;
  font-weight: 700;
  font-size: 16px;
  line-height: 21px;
  text-align: center;
  margin: 40px 0;
  width: 310px;
  height: 56px;
  padding: 16px;

  > svg {
    margin-left: 12px;
    transform: rotate(-90deg);
  }
`;
